import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { adminMainUrl } from "../../../../../Config";
import axios from "axios";

const BasicInfoEdit = ({
    loadingLedgerAccountDetail,
    LedgerAccountDetail,
    LedgerAccountDetailError,
    showLedgerDetail,
    handleCloseLedgerDetail,
    refreshLedger
}) => {
    const {
        // GroupMasterName,
        // loadingGroupMasterName,
        // MasterAccountGroupName,
        // loadingMasterAccountGroupName,
    } = useSelector((state) => state?.MasterReducer);

    let [GroupMasterName, setGroupMasterName] = useState([]);
    let [MasterAccountGroupName, setMasterAccountGroupName] = useState([]);
    useEffect(() => {
        axios.get(`${adminMainUrl}/api/account/group-master-name`)
            .then((res) => {
                if (res?.data?.data) {
                    setGroupMasterName(res.data.data)
                } else {
                    setGroupMasterName([])
                }
            })
        axios.get(`${adminMainUrl}/api/account/account-group-name`)
            .then((res) => {
                if (res?.data?.data) {
                    setMasterAccountGroupName(res.data.data)
                } else {
                    setMasterAccountGroupName([])
                }
            })
    }, [])



    const [isSubmitting, setIsSubmitting] = useState(false);

    const formik = useFormik({
        initialValues: {
            ledger_code: "",
            ledger_party_name: "",
            ledger_group: "",
            ledger_sales_person: "",
            ledger_account_group: "",
            ledger_opening_balance: "",
            ledger_credit_limit: "",
            ledger_credit_day: "",
            ledger_debit_or_credit: "",
            ledger_type: "",
            ledger_gst: "",
        },

        onSubmit: async (values, { resetForm }) => {
            setIsSubmitting(true);
            let updatedRes = {
                ...values,
                ledger_credit_limit: Number(values.ledger_credit_limit) || 0,
                ledger_opening_balance:
                    Number(values.ledger_opening_balance) || 0,
                ledger_credit_day: Number(values.ledger_credit_day) || 0,
            }
            // console.log(updatedRes);
            try {
                const response = await fetch(
                    `${adminMainUrl}/api/account/update-ledger-account`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "auth-token": Cookies.get("token"),
                            user_id: Cookies.get("flexichain_user_id"),
                        },
                        body: JSON.stringify(updatedRes),
                    }
                );

                const data = await response.json();

                if (response.ok) {
                    toast.success(data?.msg || "Ledger account updated successfully");
                    // handleCloseLedgerDetail();
                    refreshLedger(LedgerAccountDetail.id)
                } else {
                    toast.error(data?.msg || "Failed to update ledger account");
                }
            } catch (error) {
                console.log(error)
                toast.error("Something went wrong. Please try again.");
            } finally {
                setIsSubmitting(false);
            }
        },
    });

    useEffect(() => {
        if (LedgerAccountDetail) {

            formik.setFieldValue("id", LedgerAccountDetail.id);
            formik.setFieldValue("ledger_code", LedgerAccountDetail.ledger_code);
            formik.setFieldValue("ledger_party_name", LedgerAccountDetail.ledger_party_name);
            formik.setFieldValue("ledger_sales_person", LedgerAccountDetail.ledger_sales_person);
            formik.setFieldValue("ledger_opening_balance", LedgerAccountDetail.ledger_opening_balance);
            formik.setFieldValue("ledger_credit_limit", LedgerAccountDetail.ledger_credit_limit);
            formik.setFieldValue("ledger_credit_day", LedgerAccountDetail.ledger_credit_day);
            formik.setFieldValue("ledger_debit_or_credit", LedgerAccountDetail.ledger_debit_or_credit);
        }
    }, [LedgerAccountDetail]);
    useEffect(() => {
        if (LedgerAccountDetail) {
            formik.setFieldValue("ledger_account_group", LedgerAccountDetail.ledger_account_group);
        }
    }, [MasterAccountGroupName])
    useEffect(() => {
        if (LedgerAccountDetail) {
            formik.setFieldValue("ledger_group", LedgerAccountDetail.ledger_group);
        }
    }, [GroupMasterName])

    return (
        <>
            <div className="row">
                {/* Ledger Code */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-medium">
                        Ledger Code <span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        className="form-control bg-light"
                        disabled
                        readOnly
                        value={formik.values.ledger_code}
                    />
                </div>

                {/* Party Name */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-medium">
                        Party Name <span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        name="ledger_party_name"
                        className="form-control bg-light"
                        onChange={formik.handleChange}
                        value={formik.values.ledger_party_name}
                    />
                    {formik.errors.ledger_party_name && (
                        <small className="text-danger">
                            {formik.errors.ledger_party_name}
                        </small>
                    )}
                </div>

                {/* Group */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-medium">
                        Group Name <span className="text-danger">*</span>
                    </label>
                    <select
                        name="ledger_group"
                        className="form-select bg-light"
                        onChange={formik.handleChange}
                        value={formik.values.ledger_group}
                    // disabled={loadingGroupMasterName}
                    >
                        <option value="">Select group</option>
                        {GroupMasterName?.map((item) => (
                            <option key={item.id} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Sales Person */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-medium">Sales Person</label>
                    <input
                        type="text"
                        name="ledger_sales_person"
                        className="form-control bg-light"
                        onChange={formik.handleChange}
                        value={formik.values.ledger_sales_person}
                    />
                </div>

                {/* Account Group */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-medium">
                        Account Group <span className="text-danger">*</span>
                    </label>
                    <select
                        name="ledger_account_group"
                        className="form-select bg-light"
                        onChange={formik.handleChange}
                        value={formik.values.ledger_account_group}
                    // disabled={loadingMasterAccountGroupName}
                    >
                        <option value="">Select account group</option>
                        {MasterAccountGroupName?.map((item) => (
                            <option key={item.id} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Opening Balance */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-medium">Opening Balance</label>
                    <input
                        type="number"
                        name="ledger_opening_balance"
                        className="form-control bg-light"
                        onChange={formik.handleChange}
                        value={formik.values.ledger_opening_balance}
                    />
                </div>
                {/* Credit Limit */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-medium">Credit Limit</label>
                    <input
                        type="number"
                        name="ledger_credit_limit"
                        className="form-control bg-light"
                        onChange={formik.handleChange}
                        value={formik.values.ledger_credit_limit}
                    />
                </div>
                {/* Credit Days */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-medium">Credit Day</label>
                    <input
                        type="number"
                        name="ledger_credit_day"
                        className="form-control bg-light"
                        onChange={formik.handleChange}
                        value={formik.values.ledger_credit_day}
                    />
                </div>

                {/* DR / CR */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-medium">
                        DR/CR <span className="text-danger">*</span>
                    </label>
                    <select
                        name="ledger_debit_or_credit"
                        className="form-select bg-light"
                        onChange={formik.handleChange}
                        value={formik.values.ledger_debit_or_credit}
                    >
                        <option value="">Select</option>
                        <option value="DEBIT">DEBIT</option>
                        <option value="CREDIT">CREDIT</option>
                    </select>
                </div>

                {/* Submit */}
                <div className="d-flex gap-2 mt-4">
                    <button
                        type="button"
                        onClick={formik.handleSubmit}
                        className="btn btn-primary px-4"
                        disabled={isSubmitting}
                        style={{ float: "right" }}
                    >
                        {isSubmitting ? "Saving..." : "Save & Next"}
                    </button>
                </div>
            </div>
        </>
    );
};

export default BasicInfoEdit;
